import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { enforceProductionLogging } from "./lib/secureLogger";

// Enforce secure logging in production (sanitize console output)
enforceProductionLogging();

// Warn if page is loaded over HTTP in production (except localhost)
if (import.meta.env.PROD && 
    window.location.protocol === 'http:' && 
    !window.location.hostname.includes('localhost')) {
  console.warn('[Security] Page loaded over insecure HTTP connection');
}

createRoot(document.getElementById("root")!).render(<App />);
